import React from 'react';

interface ResetFiltersButtonProps {
    /** Clears every filter on the form. Column selection is left alone — the
     * column picker has its own "Reset to default". */
    onReset: () => void;
    /** True when no filter is set, so the button reads as available without
     * being a dead click. */
    disabled?: boolean;
}

const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({
    onReset,
    disabled = false,
}) => (
    <button
        type='button'
        onClick={onReset}
        disabled={disabled}
        className='rounded-lg border border-gray-400 px-8 py-3 text-center text-sm font-medium text-body hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200 disabled:cursor-not-allowed disabled:opacity-40'
    >
        Reset Filters
    </button>
);

export default ResetFiltersButton;
